export const modelOption = ["COLPER-5000K", "ACR-100PLUS","MG600S"];

export const colperOption = ["SCL-KR", "SF-JR", "TFO-K(TFOD-112)-4P", "MITSU 5HP Ø 1Phase SCL-QR", "Pioneer 5HP Ø 1Phase" , "Pioneer 1HP Ø 4P 1Phase" ];

export const acr100Option = ["SM-3.0CR" , "Pioneer 3HP Ø 4P 1Phase" ];
